import React, { Component } from "react"

export default class TOM extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">LIBERTY</p>
            <p className="portdesctext">For <a href = "https://vimeo.com/395197592" target="_blank" rel="noopener noreferrer">"The Fields of Algorithims" by David Blandy</a> in collaboration with Peri Heath. Modified game Mount & Blade Warband using mod tools to implement models made using Blender, Gimp, & Photoshop. Shot in game with audio from youtube. Abstract <a href = "https://www.dropbox.com/s/ken7ly8hagm8s6m/LIBERTY%20%28publish%29.pdf?dl=0" target="_blank" rel="noopener noreferrer">here</a>.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href="https://www.dropbox.com/s/nc96fkt6f4es88j/AliRazzakPerryHeath_TheOneMinutes_Final_sound.mov?dl=0" target="_blank" rel="noopener noreferrer"><p className="linktext">Video</p></a>
        </div>
      </div>
  )
}
}

